import { render, staticRenderFns } from "./life.vue?vue&type=template&id=545cbc46&scoped=true&"
import script from "./life.vue?vue&type=script&lang=js&"
export * from "./life.vue?vue&type=script&lang=js&"
import style0 from "./life.vue?vue&type=style&index=0&id=545cbc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cbc46",
  null
  
)

export default component.exports